export const DIMENSION_TITLE_MAP: Record<string, string> = {
    Vendor: 'Vendors',
    Category: 'Categories',
    'Sub Category': 'Sub Categories',
    Segment: 'Segments',
    Occasion: 'Occasions',
    Brand: 'Brands',
    'Sub Brand': 'Sub Brands',
    PPG: 'PPGs',
    'Pack Size': 'Pack Sizes',
    Form: 'Forms',
    Country: 'Countries',
    Channel: 'Channels',
    Retailer: 'Retailers',
    Division: 'Divisions',
    Geography: 'Geographies',
};

export const getConfigurationTitle = (dimensionLabel: string) => {
    const titleLabel = DIMENSION_TITLE_MAP[dimensionLabel] ?? dimensionLabel;
    return `Axis Configuration: ${titleLabel}`;
};

export const getOtherGroupLabel = (dimensionLabel: string) =>
    `Other ${DIMENSION_TITLE_MAP[dimensionLabel] ?? dimensionLabel}`;
